import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局样式
import '@/assets/styles/global.scss'
// 工具函数
import * as validate from '@/utils/validate'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 挂载全局验证方法
Vue.prototype.$validate = validate

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')